export type UserPlan = 'free' | 'pro' | 'enterprise';

/** Ücretsiz planda canlı toplantı üst sınırı (dakika). */
export const FREE_MEETING_MAX_DURATION_MINUTES = 50;

/** Ücretsiz planda planlanan toplantı süresi alt sınırı (dakika). */
export const FREE_SCHEDULED_MEETING_MIN_MINUTES = 10;

export const FREE_MEETING_MAX_DURATION_SECONDS =
  FREE_MEETING_MAX_DURATION_MINUTES * 60;

/** Süre dolmadan önce uyarı (saniye). */
export const MEETING_LIMIT_WARNING_SECONDS = 5 * 60;

export function normalizeUserPlan(raw?: string | null): UserPlan {
  const value = (raw || 'free').toLowerCase();
  if (value === 'pro') return 'pro';
  if (value === 'enterprise' || value === 'kurumsal') return 'enterprise';
  return 'free';
}

export function getUserPlan(user: { plan?: string } | null | undefined): UserPlan {
  return normalizeUserPlan(user?.plan);
}

export function getPlanLabel(plan: UserPlan): string {
  const labels: Record<UserPlan, string> = {
    free: 'Ücretsiz',
    pro: 'Pro',
    enterprise: 'Kurumsal',
  };
  return labels[plan];
}

export function hasUnlimitedMeetingDuration(plan: UserPlan): boolean {
  return plan === 'pro' || plan === 'enterprise';
}

/** null = sınırsız */
export function getMeetingDurationLimitSeconds(plan: UserPlan): number | null {
  return hasUnlimitedMeetingDuration(plan) ? null : FREE_MEETING_MAX_DURATION_SECONDS;
}

/**
 * Canlı oda süresi: planlanan toplantı süresi (dk), plan üst sınırı ile sınırlı.
 * Pro/enterprise: planlanan süre (üst sınır yok).
 */
export function resolveRoomDurationLimitSeconds(
  plan: UserPlan,
  plannedDurationMinutes: number | string | null | undefined
): number | null {
  const planMax = getMeetingDurationLimitSeconds(plan);
  const minutes = Number(plannedDurationMinutes);
  const planned =
    Number.isFinite(minutes) && minutes > 0 ? Math.round(minutes * 60) : null;

  if (planMax == null) {
    return planned;
  }
  if (planned == null) {
    return planMax;
  }
  return Math.min(planned, planMax);
}

export function getMaxScheduledMeetingMinutes(plan: UserPlan): number {
  return hasUnlimitedMeetingDuration(plan) ? 480 : FREE_MEETING_MAX_DURATION_MINUTES;
}
